import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'

import ProductChoiceItem from './ProductChoiceItem'
import ratingProducts from '../../../../config/RatingProducts'
import {
  CHANGE_SUBMISSION_STATUS,
  CLEAR_SUBMISSION,
  SUBMISSION_STATUS,
} from '../../../constants/submission'

export const ProductChoice = ({ dispatch, user }) => {
  useEffect(() => {
    dispatch({
      type: CHANGE_SUBMISSION_STATUS,
      status: SUBMISSION_STATUS.SELECTION,
    })
    dispatch({ type: CLEAR_SUBMISSION })
  }, [])

  const items = useMemo(() => {
    if (user) {
      return Object.keys(ratingProducts).map((productType, idx) => {
        const { name, subtitle, description, features, applicationForm } =
          ratingProducts[productType]

        return (
          <Col key={idx} lg={6} md={6} sm={6} xs={12}>
            <ProductChoiceItem
              type={productType}
              name={name}
              subtitle={subtitle}
              description={description}
              features={features}
              broker={user.brokerId}
              applicationForm={applicationForm}
            />
          </Col>
        )
      })
    }

    return null
  }, [user, ratingProducts])

  if (!user) return null

  return (
    <div className="productChoice routeContainer">
      <Col>
        <h3>Get a quote</h3>
        <Row>
          <div className="selectionCards">{items}</div>
        </Row>
      </Col>
    </div>
  )
}

ProductChoice.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object,
}

export default connect((store) => ({
  user: store.user,
}))(ProductChoice)
